import { render, staticRenderFns } from "./MainMenuHeader.vue?vue&type=template&id=76156993&scoped=true&"
import script from "./MainMenuHeader.vue?vue&type=script&lang=js&"
export * from "./MainMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuHeader.vue?vue&type=style&index=0&id=76156993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76156993",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VExpansionPanelHeader } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VExpansionPanelHeader,VFlex,VIcon,VLayout,VTooltip})
